import { customLocalStorage } from 'utils/storage';

// 由于优化目标转化为了深层目标和浅层目标，所以用户缓存的数据也需要转换
function advertCvtColStorageUpdate(path: string) {
  const preStorageStr = customLocalStorage.getItem(path);

  try {
    const preStorage: string[] = JSON.parse(preStorageStr!);
    if (!preStorage || !(preStorage instanceof Array)) {
      return;
    }

    const i = preStorage.indexOf('conversionEventName');
    if (i < 0) {
      return;
    }

    preStorage.splice(i, 1, 'shallowCvtGoal', 'deepCvtGoal');

    customLocalStorage.setItem(path, JSON.stringify(preStorage));
  } catch (error) {
    console.log(error);
  }
}

// 下个需求就可以删除这个方法的调用了
export function advertCvtColConvert() {
  ['DSP-advert-column', 'DSP-advert-group-column'].forEach((path) => advertCvtColStorageUpdate(path));
}
